export default "__VITE_ASSET__B9yeX1zn__"